module.exports = __webpack_public_path__ + "img/terroir-bright-1-mobile.51196d9b.jpg";